// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1_v1F","signatureButtonsRight":"ModalSign_signatureButtonsRight__2ReKc"};